import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import SmoothScroll from "@/components/SmoothScroll";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

import HomePage from "@/pages/HomePage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import HowWeDesignPage from "@/pages/HowWeDesignPage";
import AboutPage from "@/pages/AboutPage";
import WhoWeWorkWithPage from "@/pages/WhoWeWorkWithPage";
import InsightsIndexPage from "@/pages/InsightsIndexPage";
import InsightDetailPage from "@/pages/InsightDetailPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/programs/:slug" element={<ProgramDetailPage />} />
            <Route path="/how-we-design" element={<HowWeDesignPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/who-we-work-with" element={<WhoWeWorkWithPage />} />
            <Route path="/insights" element={<InsightsIndexPage />} />
            <Route path="/insights/:slug" element={<InsightDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}
